/**
 * @module store/index
 * @description Vuex 루트 스토어 — auth, ui, service 모듈을 조합합니다.
 * vuex-persistedstate 플러그인을 통해 auth.user와 service.serviceType을
 * sessionStorage에 자동 영속화합니다.
 */
import { createStore } from 'vuex'
import persistedstate from 'vuex-persistedstate'
import auth from './modules/auth'
import ui from './modules/ui'
import service from './modules/service'

const store = createStore({
  modules: {
    auth,
    ui,
    service
  },
  plugins: [
    persistedstate({ paths: ['auth.user', 'service.serviceType'] })
  ]
})

export default store
